export const API_TESTIMONIALS = {
  key: "API_KEY_GET_TESTIMONIALS",
  path: "/api/testimonials",
};
